export const SCOPE = "modules/calling/";

export const CREATE_TOKEN = SCOPE + "CREATE_TOKEN";



// WEBPACK FOOTER //
// ./src/modules/calling/types.js